<script lang="ts">
import { mdastRenderer } from '../../utils/mdastRenderer'

export default {
  props: {
    text: String,
    aos: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const wrapperData: UtilityTextData = {
      class: 'dbc-gt-text',
    }

    if (!isWebview()) {
      if (props.aos?.fadeDirection) {
        wrapperData['data-aos'] = props.aos.fadeDirection
      }
      if (props.aos?.delay) {
        wrapperData['data-aos-delay'] = props.aos.delay
      }
    }

    // Strapi Text mandatory
    // Marketing hits Enter ('\n') to to bypass this restriction
    if (props.text === '\n') return

    const wrapperDiv = h('div', wrapperData, {
      default: () => mdastRenderer(props.text),
    })

    return () => wrapperDiv
  },
}
</script>
